import React, { useEffect, useState } from 'react'
import { Box, Typography, Grid, Card, CardMedia, CardContent, CardActionArea, CircularProgress } from '@mui/material'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { axiosi } from '../config/axios'

export const SearchResultsPage = () => {
  const [searchParams] = useSearchParams()
  const q = searchParams.get('q') || ''
  const [results, setResults] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const fetch = async () => {
      if (!q.trim()) return setResults([])
      setIsLoading(true)
      try {
        const res = await axiosi.get('/products', { params: { q, limit: 48 } })
        const data = res.data.data || res.data || []
        setResults(Array.isArray(data) ? data : [])
      } catch (err) {
        console.error(err)
        setResults([])
      } finally {
        setIsLoading(false)
      }
    }
    fetch()
  }, [q])

  return (
    <Box p={2}>
      <Typography variant='h5' mb={2}>Search results for "{q}"</Typography>
      {isLoading ? (
        <Box display={'flex'} justifyContent={'center'} mt={4}><CircularProgress /></Box>
      ) : results.length === 0 ? (
        <Typography color='text.secondary'>No results found.</Typography>
      ) : (
        <Grid container spacing={2}>
          {results.map((p) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={p._id}>
              <Card>
                <CardActionArea onClick={() => navigate(`/product-details/${p._id}`)}>
                  {p.images && p.images[0] && (
                    <CardMedia component='img' height='140' image={p.images[0]} alt={p.title} />
                  )}
                  <CardContent>
                    <Typography variant='body1' fontWeight={600}>{p.title}</Typography>
                    <Typography variant='caption' color='text.secondary'>Rs. {p.price}</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  )
}

export default SearchResultsPage
